export default {"src":"/_next/static/media/sp.efe30fb1.svg","height":341,"width":512,"blurWidth":0,"blurHeight":0};